import React from 'react';

import {Provider} from "react-redux";

import RecommendContainer from "./container/RecommendContainer";

import configure from '../../store/configure';
import Layout from "../../component/layout/Layout";

const RecommendPage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <RecommendContainer />
            </Layout>
        </Provider>
    );
};


export default RecommendPage;
